import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import StudentAdmission from "./pages/StudentAdmission";
import StudentDirectory from "./pages/StudentDirectory";
import Fees from "./pages/Fees";
import ProtectedRoute from "./components/ProtectedRoute";
import FeeHistory from "./pages/FeeHistory";
import Attendance from "./pages/Attendance";
import AttendanceHistory from "./pages/AttendanceHistory";
import Notifications from "./pages/Notifications";
import NotificationHistory from "./pages/NotificationHistory";
import Staff from "./pages/Staff";
import Salary from "./pages/Salary";
import SalaryHistory from "./pages/SalaryHistory";
import Promotion from "./pages/Promotion";
import ExamMarks from "./pages/ExamMarks";
import ResultHistory from "./pages/ResultHistory";
import ParentLogin from "./pages/ParentLogin";
import ParentDashboard from "./pages/ParentDashboard";
import Transport from "./pages/Transport";
import TransportAssignment from "./pages/TransportAssignment";
import Layout from "./components/Layout";
import Settings from "./pages/Settings";
import Permissions from "./pages/Permissions";
import Users from "./pages/Users";
import PermissionRoute from "./components/PermissionRoute";
import ChangePassword from "./pages/ChangePassword";
import StudentProfile from "./pages/StudentProfile";

function App() {
    return (
        <BrowserRouter>
            <Routes>

                {/* Login Page */}
                <Route path="/" element={<Login />} />

                {/* Dashboard */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="dashboard">
                                <Layout>
                                    <Dashboard />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />

                {/* Students */}
                <Route
                    path="/student-admission"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="students">
                                <Layout>
                                    <StudentAdmission />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/student-directory"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="students">
                                <Layout>
                                    <StudentDirectory />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/student/:id"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="students">
                                <Layout>
                                    <StudentProfile />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />
 

                {/* Fees */}
                <Route
                    path="/fees"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="fees">
                                <Layout>
                                    <Fees />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/fee-history"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <FeeHistory />
                                </Layout>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/attendance"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="attendance">
                                <Layout>
                                    <Attendance />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="/attendance-history"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <AttendanceHistory />
                            </Layout>      
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/notifications"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <Notifications />
                            </Layout>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/notification-history"
                    element={
                        <ProtectedRoute>
                            <NotificationHistory />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/staff"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="staff">
                                <Layout>
                                    <Staff />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/salary"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="salary">
                                <Layout>
                                    <Salary />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="/salary-history"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <SalaryHistory />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/promotion"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <Promotion />
                                </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/exam-marks"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="exam_marks">
                                <Layout>
                                    <ExamMarks />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="/result-history"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <ResultHistory />
                            </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/parent-login"
                    element={<ParentLogin />}
                />
                <Route
                    path="/parent-dashboard"
                    element={<ParentDashboard />}
                />
                <Route
                    path="/transport"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <Transport />
                                </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/transport-assignment"
                    element={
                        <ProtectedRoute>
                            <Layout>
                                <TransportAssignment />
                                </Layout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/settings"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="settings">
                                <Layout>
                                    <Settings />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/permissions"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="permissions">
                                <Layout>
                                    <Permissions />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <PermissionRoute permission="users">
                                <Layout>
                                    <Users />
                                </Layout>
                            </PermissionRoute>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/change-password"
                    element={<ChangePassword />}
                />

            </Routes>

          

        </BrowserRouter>
    );
}

export default App;